export default "<h3>Coupon Management Settings</h3>\n<app-api-new [source]=\"data\"></app-api-new>\n"